import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface BrandButtonProps {
  label: string;
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  className?: string;
}
const sizeStyles: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-5 py-3 text-sm',
  lg: 'px-7 py-4 text-base'
};
export function BrandButton({
  label,
  to = '/book',
  size = 'md',
  withArrow = false,
  className = ''
}: BrandButtonProps) {
  return <Link to={to} className={`group inline-flex items-center justify-center gap-2 rounded-lg bg-brand font-semibold text-ink-900 transition-colors duration-200 hover:bg-brand-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900 ${sizeStyles[size]} ${className}`} data-id="element-41" data-mp="fcbyyx7sxzsa">
      {label}
      {withArrow && <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-42" data-mp="3sr86vtp6xiyu" />}
    </Link>;
}